module.exports = __webpack_public_path__ + "10d926df40ca556c49072ca6bf15aaf2.pdf";